import styled from 'styled-components';
import { Box as MuiBox } from '@material-ui/core';

export const ContentBox = styled(MuiBox)`
  padding: ${({ theme }) => theme.spacing(5)}px;
  background-color: ${({ theme }) => theme.palette.background.dark};
`;
